import React from "react";

export default function LogoImage(props) {
  const { logo, logoLink, alt } = props;

  if (!logo && !logoLink) {
    return null;
  }

  return (
    <a data-testid="t-LogoIma-a" href={logoLink} target={logoLink ? "_blank" : null}>
      <img className="m-site-logo" src={logo} alt={alt} />
    </a>
  );
}
